import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import {getUsersByChampionship} from '../../../../../actions/entities/statistics/activeUsers';
import FilterLocation from '../../../../../components/Filters/Location';
import Loader from '../../../../../components/Loader';
import {getChampionships} from '../../../../../actions/entities/championships';
import {isEmpty} from 'lodash';
import getAvailableFlagsButtons from '../../../../../helpers/getAvailableFlagsButtons';
import {champIds} from '../../../../../../src/helpers/championship';
import {AVAILABLE_SEASONS} from '../../../../../types/common';

class UsersByChampionshipWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      championship: 'FR',
      season: AVAILABLE_SEASONS[0],
      data: null,
      loading: false,
    };
  }

  toggleChamp(value) {
    this.fetchStats(value);
    this.setState({championship: value});
  }

  renderTable() {
    const {data} = this.state;
    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <td className="text-center">
                <b>Journée</b>
              </td>
              <td className="text-center">
                <b>Users(live)</b>
              </td>
              <td className="text-center">
                <b>Users actifs les 15 derniers</b>
              </td>
              <td className="text-center">
                <b>Matchs MPG</b>
              </td>
              <td className="text-center">
                <b>Date de calcul</b>
              </td>
            </tr>
          </thead>
          <tbody>
            {data.map(
              ({
                gameWeek,
                usersQuantity,
                activeUsersQuantity,
                matchesQuantity,
                gameWeekDate,
              }) => {
                return (
                  <tr>
                    <td className="text-center">{gameWeek}</td>
                    <td className="text-center">
                      {usersQuantity.toLocaleString()}
                    </td>
                    <td className="text-center">
                      {activeUsersQuantity.toLocaleString()}
                    </td>
                    <td className="text-center">
                      {matchesQuantity.toLocaleString()}
                    </td>
                    <td className="text-center">
                      {moment(gameWeekDate).format('DD/MM/YYYY')}
                    </td>
                  </tr>
                );
              },
            )}
          </tbody>
        </table>
      </div>
    );
  }

  fetchStats(championship) {
    const {dispatch} = this.props;
    const {season} = this.state;
    const onSuccess = response =>
      this.setState({data: response.usersMatchesBreakdown, loading: false});
    dispatch(
      getUsersByChampionship(
        {
          championship: champIds[championship || this.state.championship],
          season,
        },
        onSuccess,
        null,
        () => this.setState({loading: true}),
      ),
    );
  }

  componentDidMount() {
    this.props.dispatch(getChampionships());
  }

  render() {
    const {championship, season, data, loading} = this.state;
    const {championships} = this.props;

    if (isEmpty(championships)) {
      return <></>;
    }

    return (
      <div id="season-active-users-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-user-circle-o" /> Users by championship
            </h3>
          </div>
          <div className="box-body text-center">
            <div className="margin-bottom text-center inline">
              <FilterLocation
                label="Championship:"
                availableButtons={getAvailableFlagsButtons(
                  this.props.championships,
                )}
                onChange={championship => this.toggleChamp(championship)}
                initialValue={championship}
              />
              <select
                style={{width: '200px'}}
                className="inline form-control"
                value={season}
                onChange={e => this.setState({season: e.target.value})}>
                {AVAILABLE_SEASONS.map(season => (
                  <option value={season}>{season}</option>
                ))}
              </select>
              <button
                className="ml-2 inline btn btn-default"
                onClick={() => this.fetchStats()}>
                <i className="fa fa-refresh" />
              </button>
            </div>
            {data && this.renderTable()}
          </div>
          {loading && <Loader />}
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {championships} = state.app;
    return {
      championships: championships.list.data,
    };
  },
  dispatch => ({dispatch}),
)(UsersByChampionshipWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/UsersByChampionship/index.js